import { useState, useEffect } from "react";

export const OfflineStatus = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    // Define event handlers for browser online/offline events
    const handleOffline = () => {
      setIsOffline(true);
    };

    const handleOnline = () => {
      setIsOffline(false);
    };

    // Check connection status immediately on mount
    setIsOffline(!navigator.onLine);

    // Add event listeners
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // Firefox can sometimes be inconsistent with online/offline events
    // Adding a periodic check as a fallback for Firefox
    const intervalId = setInterval(() => {
      const currentStatus = !navigator.onLine;
      if (isOffline !== currentStatus) {
        setIsOffline(currentStatus);
      }
    }, 5000); // Check every 5 seconds

    // Clean up event listeners and interval on unmount
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      clearInterval(intervalId);
    };
  }, [isOffline]); // Adding isOffline as dependency for the interval check

  // Only show the offline message if we're offline
  if (!isOffline) {
    return null;
  }

  // When offline, return a fullscreen overlay that prevents interactions
  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex flex-col items-center justify-center text-white"
      style={{
        pointerEvents: "all",
      }}
    >
      <div className="max-w-lg mx-auto p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">U bent offline</h2>
        <p className="text-xl mb-6">
          Het ziet er naar uit dat uw verbinding met internet is verloren. Zodra
          het internet / Wifi weer beschikbaar is, zal deze melding verdwijnen.
          Uw gegevens zijn opgeslagen op dit apparaat en kunnen later worden
          verder bewerkt.
        </p>
        <div className="animate-pulse flex justify-center">
          <div className="w-3 h-3 bg-white rounded-full mx-1"></div>
          <div className="w-3 h-3 bg-white rounded-full mx-1 animate-delay-200"></div>
          <div className="w-3 h-3 bg-white rounded-full mx-1 animate-delay-400"></div>
        </div>
      </div>
    </div>
  );
};

export default { OfflineStatus };
